export default "__VITE_ASSET__BaOp4Oaq__"